import { Handle, Position } from '@xyflow/react';
import { availableGroups } from 'store/utils/knowledgeGraphOntologyIcons';
import NodeChild from 'components/knowledgeGraph/components/nodes/NodeChild';
import styles from 'components/knowledgeGraph/components/nodes/CustomNode.module.scss';
import { sortChildNodes } from 'components/knowledgeGraph/utils/nodeUtils';
import { useMemo } from 'react';

const CustomNode = ({ id, data }) => {
  const { node, childNodes, isSimplifiedView } = data; // Get simplified view state from data
  // Add these props from data
  const { onChildMouseEnter, onChildClick } = data;

  const nodeOntologyType = availableGroups[node.ontologyType] ? node.ontologyType : 'none';
  const ontologyColor = availableGroups[nodeOntologyType]?.color || 'inherit';

  const sortedChildNodes = useMemo(() => {
    return childNodes ? sortChildNodes(childNodes) : [];
  }, [childNodes]);

  if (!node) return null;

  // Determine title class based on view mode
  const titleClassName = `${styles.title} ${isSimplifiedView ? styles.titleSimplified : styles.titleNormal}`;

  return (
    <div className={styles.container} data-node-id={id}>
      {/* Hidden handles for connecting edges */}
      <Handle type="source" position={Position.Right} style={{ opacity: 0, pointerEvents: 'none' }} />
      <Handle type="target" position={Position.Left} style={{ opacity: 0, pointerEvents: 'none' }} />

      <div
        className={styles.header}
        onMouseEnter={e => onChildMouseEnter(node, e)}
        onClick={e => onChildClick(node, e)}
      >
        <span className={titleClassName} style={{ color: ontologyColor }}>
          {node.name}
        </span>
      </div>

      {/* Only render child nodes if not in simplified view */}
      {!isSimplifiedView && sortedChildNodes && sortedChildNodes.length > 0 && (
        <div className={styles.childContainer}>
          {/* This div creates the full-width horizontal separator */}
          <div className={styles.childContainerBorder}></div>
          {sortedChildNodes.map((child, index) => (
            <NodeChild
              key={`${child.id}-${index}`}
              child={child}
              onMouseEnter={onChildMouseEnter}
              onClick={onChildClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export const nodeTypes = { customNode: CustomNode };

export default CustomNode;
